import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type QuizSubmissionDTO = {
  questionId: string;
  choiceId: string;
  marked:boolean
};
export type QuizResponse = {
  score: number;
  status: string;
  trial: number;
  count_correct: number;
  count_wrong: number;
  count_marked: number;
  correctQuestions: {
    question: string;
    choices: {
      answer:string;
      isCorrect:boolean;
      selected:boolean
    }[]
    explanation?:string;
  }[];
  markedQuestions: {
    question: string;
    choices: {
      answer:string;
      isCorrect:boolean;
      selected:boolean
    }[]
    explanation?:string;
  }[];
  wrongQuestions: {
    question: string;
    explanation?:string;
    choices: {
      answer:string;
      isCorrect:boolean;
      selected:boolean
    }[]
  }[];
} & ApiError;
export const SubmitQuiz = (
  quizId: string,
  submissions: QuizSubmissionDTO[]
): Promise<QuizResponse> => {
  return axios.post(`/student-submit/create/${quizId}`, submissions);
};
